import * as React from "react";
import { Card, CardContent } from '@/components/ui/card';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Link2 } from 'lucide-react';

export default function ScreeningTest({ testId, className }) {
  console.log(testId)
  const testUrl = `https://aievaluator.in/questions?test_id=${testId}`;
  
  return (
    <Card className={cn("rounded-2xl bg-card border-border shadow-lg p-10 max-w-[500px] w-[90%] text-center", className)}>
      <CardContent className="p-0">
        <Stack spacing="md" align="center" className="w-full">
          <Stack spacing="sm" align="center" className="w-full">
            <Heading level="h1" className="text-3xl font-semibold text-foreground">
              Your Screening Test Link
            </Heading>
            <Text variant="muted" size="lg">
              Click the link below to start your Screening test
            </Text>
          </Stack>
          <Button
            className="w-full max-w-[400px] bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl p-3 gap-2.5 shadow-md"
            onClick={() => window.location.href = testUrl}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                window.location.href = testUrl;
              }
            }}
          >
            <Link2 className="w-6 h-6" />
            <span className="break-words">{testUrl}</span>
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}